import animation from "./animation.json";
import Lottie from "lottie-react";
import React from "react";
import styled from "styled-components";

const PageLoader: React.FC = () => {
  return (
    <Container>
      <Lottie
        animationData={animation}
        rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        className="loader-animation"
        loop
      />
    </Container>
  );
};

export default PageLoader;

const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;

  .loader-animation {
    width: 150px;
    height: 150px;
  }
`;
